import { render, staticRenderFns } from "./AddFileList.vue?vue&type=template&id=af5a7fc8&scoped=true"
import script from "./AddFileList.vue?vue&type=script&lang=js"
export * from "./AddFileList.vue?vue&type=script&lang=js"
import style0 from "./AddFileList.vue?vue&type=style&index=0&id=af5a7fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5a7fc8",
  null
  
)

export default component.exports